module.exports = __webpack_public_path__ + "static/img/banner.33ad5b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/banner.png
// module id = PQGb
// module chunks = 0